module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library4.a1077758.jpg";